<template>
  <div class="header__logos">
    <router-link
      class="header__logo"
      to="/"
    >
      <img
        :src="require('@/projects/people/assets/img/header/logo-people.png')"
        class="header__logo-pic"
        :alt="'логотип'"
      />
    </router-link>
  </div>
</template>

<script>
import { useUiStore } from '@/shared/store/useUiStore';
import {
  computed,
  defineComponent,
} from 'vue';

export default defineComponent({
  setup() {
    const uiStore = useUiStore();
    const client = computed(() => uiStore.client);

    return {
      client,
    };
  },
});
</script>
